import React, { useEffect, useRef } from "react";

export default function CheckTitle({ check, title, equipment, station }) {
  const checkRef = useRef();

  useEffect(() => {
    window.$(checkRef.current).popover();
  }, []);

  return (
    <h2>
      <span>{title}</span>{" "}
      {!!check.info && (
        <sup
          ref={(ref) => (checkRef.current = ref)}
          className="popover-checks"
          data-toggle="popover"
          data-html="true"
          data-content={`<small>${
            check.info[equipment.vendorId] &&
            check.info[equipment.vendorId][station.id]
              ? check.info[equipment.vendorId][station.id]
              : check.info[equipment.vendorId] &&
                check.info[equipment.vendorId][0]
              ? check.info[equipment.vendorId][0]
              : check.info[0] && check.info[0][0]
              ? check.info[0][0]
              : ""
          }</small>`}
        >
          <i className="fa fa-info-circle" style={{ color: "#428bca" }}></i>
        </sup>
      )}
    </h2>
  );
}
